import React from "react";
import { Link } from "react-router-dom";
import * as S from "./styles";
import { UserInfo } from "../../types/user";
import { SCHOOL_URL, SCHOOL_SIGNUP_URL } from "../../constants/urls";

interface HamburgerMenuProps {
  isOpen: boolean;
  onClose: () => void;
  userInfo: UserInfo | null;
  samName: string;
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({
  isOpen,
  onClose,
  userInfo,
  samName,
}) => {
  if (!isOpen) return null;

  return (
    <S.MobileMenu isOpen={isOpen}>
      <S.MobileMenuHeader>
        <S.CloseMenuButton onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M18.75 5.25L5.25 18.75"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.75 18.75L5.25 5.25"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </S.CloseMenuButton>
      </S.MobileMenuHeader>
      <S.MobileMenuContent>
        <Link to="/" onClick={onClose}>
          <S.MobileMenuItem>Home</S.MobileMenuItem>
        </Link>
        <Link to="/about" onClick={onClose}>
          <S.MobileMenuItem>About Us</S.MobileMenuItem>
        </Link>
        <S.MobileMenuItem
          onClick={() => {
            window.open(
              "https://goofy-may-2ac.notion.site/322d45253157809da7aad7810a4418ad",
              "_blank",
              "noopener,noreferrer"
            );
            onClose();
          }}
        >
          FAQ
        </S.MobileMenuItem>
        {userInfo ? (
          <>
            <S.MobileMenuItem>{`${samName} 선생님 반갑습니다. 😀`}</S.MobileMenuItem>
            <S.ButtonContainer>
              <S.LoginButton
                onClick={() => {
                  window.open(SCHOOL_URL, "_self");
                  onClose();
                }}
              >
                보건일지 <span>➡️</span>
              </S.LoginButton>
            </S.ButtonContainer>
          </>
        ) : (
          <S.ButtonContainer>
            <S.LoginButton
              onClick={() => {
                window.open(SCHOOL_URL, "_self");
                onClose();
              }}
            >
              로그인
            </S.LoginButton>
            <S.SignupButton
              onClick={() => {
                window.open(SCHOOL_SIGNUP_URL, "_self");
                onClose();
              }}
            >
              회원가입
            </S.SignupButton>
          </S.ButtonContainer>
        )}
      </S.MobileMenuContent>
    </S.MobileMenu>
  );
};

export default HamburgerMenu;
